import React, { useState } from "react";
import { Toggle } from "../../components/tailwind/toggle/Toggle";
import { productDetailsRefreshCurrentTab } from "../../legacy/t.product-detail";
import { store } from "../../utils/store";
import {
  NotificationAppearance,
  setDjangoToastOpen,
} from "../../api/djangoToastSlice";

type Props = {
  checked: string;
  toggleUrl: string;
};

export const TemplatesAutosaveToggle: React.FC<Props> = ({
  checked,
  toggleUrl,
}) => {
  const [isChecked, setIsChecked] = useState(checked === "true");

  const handleChange = (next: boolean): void => {
    setIsChecked(next);
    fetch(toggleUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: `enabled=${next}`,
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        productDetailsRefreshCurrentTab();
      })
      .catch(() => {
        setIsChecked(!next);
        store.dispatch(
          setDjangoToastOpen({
            appearance: NotificationAppearance.ERROR,
            content: "<strong>Error:</strong> Could not update the setting.",
          })
        );
      });
  };

  return (
    <Toggle
      checked={isChecked}
      setChecked={handleChange}
      label="Auto save changes"
    />
  );
};
